import { render, staticRenderFns } from "./AppFrame.vue?vue&type=template&id=3083c2f9&scoped=true&lang=pug&"
import script from "./AppFrame.vue?vue&type=script&lang=js&"
export * from "./AppFrame.vue?vue&type=script&lang=js&"
import style0 from "./AppFrame.vue?vue&type=style&index=0&id=3083c2f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083c2f9",
  null
  
)

export default component.exports